module.exports = __webpack_public_path__ + "img/img-3-13mobile.06f1e7fa.png";